import { Button, ChevronDownIcon, ChevronUpIcon, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
import { arrowIconStyles } from "./_localVariants";
import { SportsbookContext } from "../../contexts";
export const ViewPicks = React.memo(function ViewPicks(props) {
    const { isExpanded, purchaseId, onClick } = props;
    const { dictionary } = React.useContext(SportsbookContext);
    const config = isExpanded
        ? {
            text: dictionary.myBetsDictionary.HidePicks,
            testId: `bet-details-expanded-${purchaseId}`,
            variant: "viewPicks:Active",
        }
        : {
            text: dictionary.myBetsDictionary.ViewPicks,
            testId: `bet-details-collapsed-${purchaseId}`,
            variant: "viewPicks:Inactive",
        };
    const arrowIcon = useLocalVariant("icon", arrowIconStyles);
    return (React.createElement(Button, { onClick: onClick, testId: config.testId, variant: config.variant },
        config.text,
        isExpanded ? React.createElement(ChevronUpIcon, { accessibilityText: dictionary.myBetsDictionary.ChevronUpIcon, variant: arrowIcon }) : React.createElement(ChevronDownIcon, { accessibilityText: dictionary.myBetsDictionary.ChevronDownIcon, variant: arrowIcon })));
});
//# sourceMappingURL=ViewPicks.js.map